class BrandingService {
  get() {
    const config = import(`./${process.env.REACT_APP_BRANDING}/config.js`);
    return Promise.all([config.then((result) => result.default)]);
  }
}

export default new BrandingService();
